import { RequestStatus } from '@lib/plugin-redux-core';
import { FormCategory } from '@module/form';
import { RootReducerState } from 'redux/root.reducer';

export const formCategiresWithAllOptionsSelector = (state: RootReducerState): FormCategory[] =>
  state.formCategoriesGlobal.formCategiresWithAllOptions;

export const getFormCategiresWithAllOptionsStatusSelector = (
  state: RootReducerState,
): RequestStatus => state.formCategoriesGlobal.getFormCategiresWithAllOptionsStatus;
